export default "__VITE_ASSET__4ed01a93__"